import * as React from 'react';
import TextInputBase from 'src/inputs/TextInputBase';
import type {InputProps} from 'src/inputs/TextInputBase';

const PlainTextInput = React.forwardRef(
  (props: InputProps, ref: React.Ref<HTMLInputElement>) => {
    const {className, ...otherProps} = props;
    return (
      <TextInputBase
        ref={ref}
        className={`w-full border-none bg-transparent p-0 text-sm text-muted-foreground placeholder:italic placeholder:text-muted-foreground/60 focus:text-foreground focus:outline-none ${className ?? ''}`}
        {...otherProps}
      />
    );
  },
);

export default PlainTextInput;
